import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class cardConnectService {
  private method: string = '/cardsecure/api/v1/ccn/tokenize';

  constructor(private http: HttpClient) {
  }

  //Post to card connect and get back a token for processing
  postApple = (url: string, devicedata: string): Observable<string> => {
    let headers = new HttpHeaders();
    let urlParams = new HttpParams();
    headers.append('Content-Type', 'application/json');
    console.info('apple post', url + this.method);
    return this.http.post<string>(url + this.method, {
      "encryptionhandler": "EC_APPLE_PAY",
      "devicedata": devicedata
    }, { headers: headers, params: urlParams })
  }

  postGoogle = (url: string, devicedata: string): Observable<string> => {
    let headers = new HttpHeaders();
    let urlParams = new HttpParams();
    headers.append('Content-Type', 'application/json');
    console.info('google post', url + this.method, devicedata);
    return this.http.post<string>(url + this.method, {
      "encryptionhandler": "EC_GOOGLE_PAY",
      "devicedata": devicedata
    }, { headers: headers, params: urlParams })
  }
}
